<!-- ============================================================== -->
<!-- Only router without any element -->
<!-- ============================================================== -->
<mat-sidenav-container dir="ltr" class="light-theme green_theme"> 
  <router-outlet></router-outlet>
</mat-sidenav-container>